module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      App Name - " + _vm._s(_vm.sheetTitle) + "        \n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-12"
  }, [_c('div', {
    staticClass: "appsDiv"
  }, [_c('all-rows', {
    attrs: {
      "allRows": _vm.allRows
    }
  })], 1)])]) : _vm._e()])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/messages-dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("App Messages Rows")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3d43f709","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages-dashboard/addOrUpdate.vue
// module id = iOZY
// module chunks = 1